"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shape = void 0;
exports.shape = {
    borderRadius: {
        default: '4px',
        lg: '8px',
    },
};
//# sourceMappingURL=shape.js.map